import type { PixatwinSdkModule, PixatwinSdkModuleRegistry } from "./types";

export interface CreatePixatwinSdkModuleRegistryOptions {
  canRegister(): boolean;
}

export const createPixatwinSdkModuleRegistry = ({
  canRegister,
}: CreatePixatwinSdkModuleRegistryOptions): PixatwinSdkModuleRegistry => {
  const modules = new Map<string, PixatwinSdkModule>();

  return {
    register(module) {
      if (!canRegister()) {
        throw new Error(
          "Les modules SDK doivent être enregistrés avant le démarrage du SDK.",
        );
      }

      if (modules.has(module.id)) {
        throw new Error(`Le module SDK \"${module.id}\" est déjà enregistré.`);
      }

      modules.set(module.id, module);
    },
    list() {
      return Array.from(modules.values());
    },
  };
};
